document.addEventListener( 'facetwp-loaded', function() {
  document.querySelectorAll( '.facetwp-type-pager .facetwp-page' ).forEach( function( el ) {
    const span = document.createElement( 'span' );
    while ( el.firstChild ) {
      span.appendChild( el.firstChild );
    }
    
    el.appendChild( span );
  } );
} );